import { useFetch } from "@/hooks/useFetch";
import { PageHeader, Panel, Loading, StatCard, MockBanner } from "@/components/common";
import { CurrencyDollar, TrendUp } from "@phosphor-icons/react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";

const tooltipStyle = { background: "#121212", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12, color: "#fff", fontSize: 12 };

export default function Revenue() {
  const { data, loading } = useFetch("/revenue");
  if (loading || !data) return <Loading />;

  return (
    <div>
      <PageHeader icon={CurrencyDollar} title="Revenue Centre"
        subtitle="A complete business dashboard. Import real revenue where APIs exist, otherwise add manual entries." />
      <MockBanner>No real revenue yet — figures are $0 until platform & sales APIs connect. Costs are tracked live from AI usage estimates.</MockBanner>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <StatCard label="Revenue (month)" value={`$${data.revenue_month.toFixed(2)}`} accent="#00FF9D" />
        <StatCard label="Costs (month)" value={`$${data.costs_month.toFixed(2)}`} accent="#FFB800" />
        <StatCard label="Gross contribution" value={`$${data.gross.toFixed(2)}`} accent="#FF3366" />
        <StatCard label="Estimated profit" value={`$${data.estimated_profit.toFixed(2)}`} accent="#FF3366" icon={TrendUp} />
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        <Panel className="lg:col-span-2">
          <div className="text-sm text-zinc-400 mb-4">Revenue vs Cost trend</div>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={data.trend}>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
              <XAxis dataKey="month" stroke="#52525B" fontSize={12} /><YAxis stroke="#52525B" fontSize={12} />
              <Tooltip contentStyle={tooltipStyle} cursor={{ fill: "rgba(255,255,255,0.03)" }} /><Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="revenue" name="Revenue" fill="#00FF9D" radius={[6, 6, 0, 0]} />
              <Bar dataKey="cost" name="Cost" fill="#FFB800" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </Panel>
        <Panel>
          <div className="text-sm text-zinc-400 mb-4">Revenue streams</div>
          <div className="space-y-2">
            {data.streams.map((s) => (
              <div key={s.category} className="flex items-center justify-between rounded-lg border border-white/8 bg-black/20 px-3 py-2">
                <span className="text-sm text-white">{s.category}</span>
                <span className="font-mono text-sm text-zinc-400">${s.revenue.toFixed(2)}</span>
              </div>
            ))}
          </div>
        </Panel>
      </div>
    </div>
  );
}
